import { ParentRouteRedirect } from "../../../../../../shared/frontend/navigation/ParentRouteRedirect";

export function NotFoundPage() {
  return <ParentRouteRedirect overviewPath="/overview" />;
}



